<template>
  <div>
    <div class="app-block p-md m-md">
      <h3 class="heading-line title is-4 has-text-weight-light">
        <span
          :class="'school-title-'+school"
        >5 - Frais de dossier: {{ schoolFees }} euros</span>
      </h3>

      <div class="p-t-md">
        <div v-if="!application.promoCodes.length">
          <div>
            <input
              v-model="promoCode"
              class="input input-code"
              type="text"
              placeholder="Code bourse"
            >
            <a
              class="button has-text-success"
              style="cursor: pointer"
              :class="[!promoCode ? 'app-disabled':'']"
              @click="setPromo(promoCode)"
            >
              Valider
            </a>
          </div>
          <transition name="slide-fade">
            <div class="has-text-danger has-text-centered">
              {{ errorMsg }}
            </div>
          </transition>
        </div>
        <div v-else>
          <div>
            <span class="input-code"><i>Code bourse:</i> <strong>{{
              application.promoCodes[0].code
            }}</strong>
              <span v-if="application.promoCodes[0].valueType === 'amount'">
                (-{{ application.promoCodes[0].value }}€)
              </span>
              <span v-else-if="application.promoCodes[0].valueType === 'percentage'">
                (-{{ application.promoCodes[0].value }}%)
              </span>
            </span>

            <a
              class="button has-text-warning delete-code"
              style="cursor: pointer"
              @click="removePromo(application.promoCodes[0])"
            >
              <strong>Supprimer</strong>
            </a>
          </div>
        </div>
      </div>
      <hr>
      <div class="content">
        <div class="title is-5 has-text-weight-light">
          Veuillez régler vos frais de dossier par carte bancaire
        </div>
        <br>
        <div class="columns has-text-centered">
          <div class="column is-offset-4 is-3">
            <button
              type="submit"
              class="app-block payment-button p-t-sm"
              @click="toggleCB"
            >
              <div class="is-size-6 has-text-grey is-italic">
                Carte Bancaire
              </div>
              <br>
              <div class="is-flex is-horizontal-center ">
                <figure class="image is-64x64  ">
                  <img
                    src="/img/icons/cards.png"
                    alt=""
                  >
                </figure>
              </div>
            </button>
          </div>


          <!--<div class="column is-3">
              <button @click="toggleCheck" type="submit"
                      class="app-block payment-button p-t-sm">
                  <div class="is-size-6 has-text-grey is-italic">Chèque</div>
                  <div class="is-flex is-horizontal-center ">
                      <figure class="image is-64x64  ">
                          <img src="/img/icons/check.png">
                      </figure>
                  </div>
              </button>
          </div>


          <div class="column is-3">
              <button @click="toggleTransfert" type="submit"
                      class="app-block payment-button p-t-sm">
                  <div class="is-size-6 has-text-grey is-italic">Virement</div>
                  <br>
                  <div class="is-flex is-horizontal-center ">
                      <figure class="image is-64x64">
                          <i class="fa fa-exchange fa-5x" aria-hidden="true"></i>
                      </figure>
                  </div>
              </button>
          </div>

          <div class="column is-3">
              <button @click="toggleNote" type="submit"
                      class="app-block payment-button p-t-sm">
                  <div class="is-size-6 has-text-grey is-italic">Espèces</div>
                  <br>
                  <div class="is-flex is-horizontal-center ">
                      <figure class="image is-64x64  ">
                          <img src="/img/icons/bank-note.png">
                      </figure>
                  </div>
              </button>
          </div>-->
        </div>

        <transition name="slide-fade">
          <div
            v-if="errorShow"
            class="has-text-danger has-text-centered"
          >
            {{ errorFee }}
          </div>
        </transition>

        <div id="payment-validation">
          <transition
            name="component-fade"
            mode="out-in"
          >
            <component
              :is="paymentView"
              :school="school"
              :candidate="candidate"
              :application="application"
              :application-fees="schoolFees"
              @send="savePayment"
              @edit="editPayment"
            />
          </transition>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import CBView from '../payment/FeesCB.vue'
import CBError from '../payment/CBError.vue'
import BankCheckView from '../payment/FeesCheck.vue'
import BankNoteView from '../payment/FeesNote.vue'
import BankTransferView from '../payment/FeesTransfer.vue'
import {mapActions, mapGetters} from 'vuex'
import feesMixin from "../../../mixins/feesMixin";

export default {
  mixins: [feesMixin],
  props: {
    school: {type: String},
    schoolObject: {type: Object},
    candidate: {type: Object},
    application: {type: Object},
    errorFee: {type: String}
  },
  data() {
    return {
      paymentView: '',
      application_id: '',
      checkout: '',
      paymentInfo: '',
      paymentCheck: false,
      paymentTransfert: false,
      errorShow: true,
      errorMsg: '',
      promoCode: null,
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'init'
  },
  computed: {
    ...mapGetters({
      status: 'candidate/getStatus',
      statusMessage: 'candidate/getMessage',
      schoolChoice: 'organization/getSchoolBySlug'
    })
  },
  mounted() {
    if (this.application.paymentMode === 'BANK-CHECK') {
      this.toggleCheck()
    }
    if (this.application.paymentMode === 'BANK-TRANSFER') {
      this.toggleTransfert()
    }
  },
  methods: {
    ...mapActions({
      setCheckout: 'candidate/fetchCheckout',
      setApplicationPromo: 'candidate/setApplicationPromo',
      removeApplicationPromo: 'candidate/removeApplicationPromo',
    }),
    init() {
      this.paymentView = ''
    },
    notAuthenticated() {
      this.$emit('notAuthenticated')
    },
    toggleCB() {
      this.errorShow = false
      this.application_id = this.application.id
      this.setCheckout(this.application_id).then((result) => {
        if (this.status === 200) {
          this.paymentView = CBView
          this.$scrollTo('#payment-validation', {offset: -250}, 500)
        } else if (this.status === 403) {
          this.$emit('notAuthenticated')
        } else {
          this.paymentView = CBError
          this.$scrollTo('#payment-validation', {offset: -250}, 500)
        }
      }).catch((err) => {

        this.error = err.message
      })
    },
    setPromo: function (code) {
      let promoCode = {}
      promoCode.application = this.application.id
      promoCode.code = code
      this.setApplicationPromo(promoCode).then(() => {
        if (this.status === 200) {
        } else {
          this.errorMsg = this.statusMessage
          setTimeout(() => {
            this.errorMsg = ''
          }, 2000)
        }
      }).catch(() => {
        this.errorMsg = this.statusMessage
        setTimeout(() => {
          this.errorMsg = ''
        }, 2000)
      })
    },
    removePromo: function (promo) {
      promo.application_id = this.application.id
      this.removeApplicationPromo(promo).then(() => {
        if (this.status === 200) {
          this.paymentView = '';
        } else {
          this.errorMsg = this.statusMessage
          setTimeout(() => {
            this.errorMsg = ''
          }, 2000)
        }
      }).catch(() => {
        this.errorMsg = this.statusMessage
        setTimeout(() => {
          this.errorMsg = ''
        }, 2000)
      })
    },
    toggleCheck() {
      this.errorShow = false
      this.application_id = this.application.id
      this.paymentView = BankCheckView
      this.$scrollTo('#payment-validation', {offset: -250}, 500)
    },
    toggleTransfert() {
      this.errorShow = false
      this.application_id = this.application.id
      this.paymentView = BankTransferView
      this.$scrollTo('#payment-validation', {offset: -250}, 500)
    },
    toggleNote() {
      this.errorShow = false
      this.application_id = this.application.id
      this.paymentView = BankNoteView
      this.$scrollTo('#payment-validation', {offset: -250}, 500)
    },
    savePayment() {
      this.$emit('send')
    },
    editPayment() {
      this.$emit('edit')
    }
  }

}
</script>
<style scoped>
.is-offset-4 {
  margin-left: 37% !important;
}
.delete-code {
  margin-top: -6px;
}

.input-code {
  width: 20%;
  padding: 0.75rem;
}
</style>
